import './constants'

export default {
  tnes: {
    state: {},
    getters: {},
    mutations: {},
    actions: {},
  },
};
